import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { RouterProvider } from 'react-router-dom';
import { Provider } from 'react-redux';
import { store } from './store';
import './index.css';
import { AppRoutes } from './routes/App.routes.tsx';
import { Toaster } from './components/ui/sonner';
import { TooltipProvider } from '@/components/ui/tooltip';
import { reloadOnChunkErrorOnce } from '@/utils/chunkReload';

// Vite's own signal for a failed chunk/asset preload (e.g. a stale hash after a redeploy).
// Only suppress the default handling (which otherwise surfaces as an unhandled rejection)
// when we actually reload — if we've already retried once this session, let it surface so
// RouteErrorBoundary can show a fallback instead of looping forever.
window.addEventListener('vite:preloadError', (event) => {
  if (reloadOnChunkErrorOnce()) {
    event.preventDefault();
  }
});

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <Provider store={store}>
      <TooltipProvider>
        <RouterProvider router={AppRoutes} />
        <Toaster position="top-right" richColors />
      </TooltipProvider>
    </Provider>
  </StrictMode>
);
